import React from 'react';

const DataManagerLogo = ({ size = 200, className = "" }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <defs>
                <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#6366f1" />
                    <stop offset="100%" stopColor="#0ea5e9" />
                </linearGradient>
                <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="5" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
            </defs>
            
            {/* Outer Hexagon / Frame */}
            <path
                d="M100 10L178 55V145L100 190L22 145V55L100 10Z"
                fill="none"
                stroke="url(#logo-gradient)"
                strokeWidth="2"
                opacity="0.3"
            />

            {/* Inner Core Symbol */}
            <rect x="75" y="75" width="50" height="50" rx="10" transform="rotate(45 100 100)" fill="url(#logo-gradient)" filter="url(#glow)" />
            
            {/* Nodes / Data connections */}
            <circle cx="100" cy="40" r="6" fill="#6366f1" />
            <circle cx="160" cy="145" r="6" fill="#0ea5e9" />
            <circle cx="40" cy="145" r="6" fill="#6366f1" />
            
            <line x1="100" y1="40" x2="100" y2="70" stroke="white" strokeWidth="2" opacity="0.5" strokeDasharray="4 2" />
            <line x1="160" y1="145" x2="125" y2="125" stroke="white" strokeWidth="2" opacity="0.5" strokeDasharray="4 2" />
            <line x1="40" y1="145" x2="75" y2="125" stroke="white" strokeWidth="2" opacity="0.5" strokeDasharray="4 2" />

            <text x="100" y="112" fontFamily="Outfit, sans-serif" fontSize="24" fontWeight="900" fill="white" textAnchor="middle">DM</text>
        </svg>
    );
};

export default DataManagerLogo;
